import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { deleteDiscussion } from 'hb-react/frontoffice/apps/Forum/requests';
import { ITEMS_QUERY_KEYS } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils/queryUtils';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

export const useDeleteDiscussion = (discussionId: number) => {
  const { configUrls } = useForumContext();
  const { topicId } = useTopicContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync: mutate } = useMutation({
    mutationFn: () => deleteDiscussion({ configUrls, discussionId }),
    onSuccess: () => {
      toast.success(s__('Forum|Your discussion has been successfully deleted'));
      queryClient.invalidateQueries({
        queryKey: [ITEMS_QUERY_KEYS.forum.items, topicId],
      });
      queryClient.invalidateQueries({
        queryKey: [ITEMS_QUERY_KEYS.forum.pinnedItems, topicId],
      });
      queryClient.invalidateQueries({
        queryKey: [ITEMS_QUERY_KEYS.forum.side, topicId],
      });
      navigate(configUrls.indexUrl());
    },
    onError: () => {
      toast.error(__('Sorry, an error occurred'));
    },
  });

  return { isPending, mutate };
};
